import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators'

import { LocationDistance } from '../../models';
import { AutoUnsubscribe, QuickLaunchService } from '../../services';
@Component({
    selector: 'quick-launch',
    template: require('./quick-launch.html'),
    styles: [require('./quick-launch.css')],
})

@AutoUnsubscribe()
export class QuickLaunch implements OnInit {
    protected subscriptions: any[] = [];
    protected locations: LocationDistance[] = [];
    protected location: LocationDistance;

    constructor(private qlSvc: QuickLaunchService, private router: Router, ) { }

    ngOnInit() {
        this.subscriptions.push(this.qlSvc.nearestLocations$.pipe(switchMap(obs => obs)).subscribe((data: LocationDistance[]) => {
            this.locations = data;

            if (this.locations && this.locations.length > 0)
                this.location = this.locations[0];
        }));

        this.qlSvc.loadNearestLocations();
    }

    selectChange(evt: any) {
        this.location = this.locations.find((l: LocationDistance) => l.id === evt.target.value)
    }

    callReportClick() {
        this.router.navigate(['/callreports/callreport', 'add'], { queryParams: { companyId: this.location.id, companyName: this.location.name } });
    }

    locationSummaryClick() {
        this.router.navigate(['/company/branch', this.location.id]);
    }
}